var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m505.749 475.587-145.6-145.6c28.203-34.837 45.184-79.104 45.184-127.317 0-111.744-90.923-202.667-202.667-202.667s-202.666 90.922-202.666 202.666 90.923 202.667 202.667 202.667c48.213 0 92.48-16.981 127.317-45.184l145.6 145.6c4.16 4.16 9.621 6.251 15.083 6.251s10.923-2.091 15.083-6.251c8.341-8.341 8.341-21.824-.001-30.165zm-303.082-112.918c-88.235 0-160-71.765-160-160s71.765-160 160-160 160 71.765 160 160-71.766 160-160 160z"}));
}

SearchIcon.defaultProps = {"enableBackground":"new 0 0 512.005 512.005","viewBox":"0 0 512.005 512.005"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
